// @ts-nocheck
import {Column} from 'react-table'
import {ReportInfoCell} from './ReportsInfoCell'
import {UserLastLoginCell} from './ReportsLastLoginCell'
import {UserTwoStepsCell} from './ReportsTwoStepsCell'
import {UserActionsCell} from './ReportsActionsCell'
import {UserSelectionCell} from './ReportsSelectionCell'
import {UserCustomHeader} from './ReportsCustomHeader'
import {UserSelectionHeader} from './ReportsSelectionHeader'
import {User} from '../../core/_models'
import ContestChallengeCol from './ContestChallengeCol'
import {format} from 'date-fns'
import moment from 'moment'

const adsColumns: ReadonlyArray<Column<User>> = [
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Email' className='min-w-125px' />
    ),
    id: 'email',
    Cell: ({...props}) => <ReportInfoCell email={props.data[props.row.index].user?.email} />,
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Category' className='min-w-125px' />
    ),
    id: 'category',
    Cell: ({...props}) => (
      <>
        <div>{props.data[props.row.index].category}</div>
      </>
    ),
  },
  // {
  //   Header: (props) => (
  //     <UserCustomHeader tableProps={props} title='Display Order' className='min-w-125px' />
  //   ),
  //   accessor: 'priority',
  //   Cell: ({...props}) => <div className='text-center'>{props.data[props.row.index].priority}</div>,
  // },
  // {
  //   Header: (props) => <UserCustomHeader tableProps={props} title='URL' className='min-w-125px' />,
  //   accessor: 'redirectUrl',
  //   Cell: ({...props}) => (
  //     <div>{props.data[props.row.index].url ? <div>Yes</div> : <div>No</div>}</div>
  //   ),
  // },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='status' className='min-w-125px' />
    ),
    accessor: 'status',
    Cell: ({...props}) => (
      <>
        {' '}
        {props.data[props.row.index].status === 'resolved' ? (
          <div className='badge badge-light-success fw-bolder'>Resolved</div>
        ) : (
          <div className='badge badge-light-danger fw-bolder'>Pending</div>
        )}
      </>
    ),
  },

  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Created At' className='min-w-125px' />
    ),
    accessor: 'createdAt',
    Cell: ({...props}) => {
      const createdAt = new Date(props.data[props.row.index].createdAt)
      return <div>{moment(createdAt).format('LL')}</div>
    },
  },
  {
    Header: (props) => (
      <UserCustomHeader tableProps={props} title='Actions' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => <UserActionsCell id={props.data[props.row.index]._id} />,
  },
]

const formatName = (name) => {
  if (name.length > 30) {
    return name.slice(0, -5) + '...'
  } else {
    return name
  }
}

export {adsColumns}
